import { create } from 'zustand'

interface AppState {
  // Selected site (opens detail panel)
  selectedSiteId: string | null
  openSite: (id: string) => void
  closeSite: () => void

  // Filters
  countryFilter: string
  searchQuery: string
  setCountryFilter: (country: string) => void
  setSearchQuery: (query: string) => void

  // Auth placeholder (for later)
  isAuthenticated: boolean
  setAuthenticated: (v: boolean) => void

  // Saved sites
  savedSiteIds: string[]
  toggleSavedSite: (id: string) => void
}

const useStore = create<AppState>((set, get) => ({
  selectedSiteId: null,
  openSite: (id) => set({ selectedSiteId: id }),
  closeSite: () => set({ selectedSiteId: null }),

  countryFilter: '',
  searchQuery: '',
  setCountryFilter: (country) => set({ countryFilter: country }),
  setSearchQuery: (query) => set({ searchQuery: query }),

  isAuthenticated: false,
  setAuthenticated: (v) => set({ isAuthenticated: v }),

  savedSiteIds: [],
  toggleSavedSite: (id) => {
    const { savedSiteIds } = get()
    if (savedSiteIds.includes(id)) {
      set({ savedSiteIds: savedSiteIds.filter((s) => s !== id) })
    } else {
      set({ savedSiteIds: [...savedSiteIds, id] })
    }
  },
}))

export default useStore
